import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { spacing } from '../../common/theme/constants';
import KitButton from '../KitButton';
import { KitFlexRow } from '../KitFlexbox';
import { EditMode, TranslateFunc } from '../../common/types';
import StyledCard from './styledCard';

export interface KitEditPanelProps {
  mode: string;
  title: string;
  children: ReactNode | string;
  onSubmit: () => void;
  onCancel: () => void;
  onToggle: () => void;
  fullHeight?: boolean;
  t: TranslateFunc;
}

const FlexRowButtons = styled(KitFlexRow)`
  padding: ${spacing.absolute.m}px 0;
  button:last-child {
    margin-left: ${spacing.absolute.m}px;
    margin-right: ${spacing.absolute.m}px;
  }
`;

const KitEditPanel = (props: KitEditPanelProps) => {
  const { children, mode, onSubmit, onCancel, onToggle, t, title, fullHeight } = props;
  const isEditMode = mode === EditMode.EDIT;
  const handleCancel = (e) => {
    e.preventDefault();
    onCancel();
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit();
  };

  const handleToggle = () => {
    onToggle();
  };

  return (
    <StyledCard fullHeight={fullHeight}>
      <StyledCard.Header>
        <header>{title}</header>
        {!isEditMode && (
          <KitButton variant='link_no_padding' onClick={handleToggle}>
            {t('kit:button.edit')}
          </KitButton>
        )}
      </StyledCard.Header>
      <StyledCard.Body>
        {children}
        {isEditMode && (
          <FlexRowButtons>
            <KitButton variant='primary' onClick={handleSubmit}>
              {t('kit:button.save')}
            </KitButton>
            <KitButton variant='secondary' onClick={handleCancel}>
              {t('kit:button.cancel')}
            </KitButton>
          </FlexRowButtons>
        )}
      </StyledCard.Body>
    </StyledCard>
  );
};

export default KitEditPanel;
